import LevelNodeComponent from '../../Component/World/LevelNode';
import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import Interactable from '../../Component/Interactable';
import Container from '../Container';
import AnimationComponent from '../../Component/Animation';

export enum LevelNodeState {
    COMPLETE,
    CURRENT,
    FUTURE,
}

export default class LevelNode extends GameObject {
    protected onCreate(params: {
        x: number;
        y: number;
        levelNumber: number;
        levelState: LevelNodeState;
        stars: number;
    }): void {
        this.addComponent(TransformComponent, params);
        this.addComponent(Renderable, params);
        this.addComponent(LevelNodeComponent, params);
        this.addComponent(AnimationComponent);

        let digitTexturePostFix = '';
        let baseTexture;
        switch (params.levelState) {
            case LevelNodeState.CURRENT:
                baseTexture = 'current_level_node';
                this.addComponent(Interactable, {
                    enabled: true,
                    buttonMode: true,
                });
                break;
            case LevelNodeState.FUTURE:
                // Only future levels show 'greyed' out number sprites.
                digitTexturePostFix = 'b';
                baseTexture = 'future_level_node';
                break;
            case LevelNodeState.COMPLETE:
                baseTexture = 'passed_level_node';
                this.addComponent(Interactable, {
                    enabled: true,
                    buttonMode: true,
                });
                break;
        }

        const baseSprite = GameObject.Instantiate(Sprite, {
            texture: baseTexture,
            anchor: new Point(0.5, 0.5),
        });
        this.addChild(baseSprite);

        const numberContainer: Container = GameObject.Instantiate(Container);
        baseSprite.addChild(numberContainer);
        const numberContainerTransform = numberContainer.getComponent(
            TransformComponent
        );
        numberContainerTransform.scale.set(0.9, 0.9);
        const numberHorizontalPadding: number = 34;
        String(params.levelNumber)
            .split('')
            .forEach((digit, index) => {
                numberContainer.addChild(
                    GameObject.Instantiate(Sprite, {
                        position: new Point(index * numberHorizontalPadding, 0),
                        texture: `${digit}${digitTexturePostFix}`,
                        anchor: new Point(0.5, 0),
                    })
                );
            });

        const numberWidth: number =
            String(params.levelNumber).split('').length *
            numberHorizontalPadding;
        numberContainerTransform.pivot.set(numberWidth * 0.5, 30);
        numberContainerTransform.position.set(8, 0);

        // Render stars.
        if (params.levelState !== LevelNodeState.FUTURE) {
            const starContainer: Container = GameObject.Instantiate(Container);

            // Relative positions of stars.
            let starPositions = [
                { x: 0, y: 40 },
                { x: 40, y: 50 },
                { x: 80, y: 40 },
            ];

            // Always render three star sprites.
            for (let i = 0; i < 3; i++) {
                let starTexture;
                //let starTextureAtlas;
                if (params.stars >= i + 1) {
                    starTexture = 'star_bright';
                    //starTextureAtlas = 'game_atlas';
                } else {
                    //starTextureAtlas = 'game2_atlas';
                    starTexture = 'star_slot';
                }

                const starSprite = GameObject.Instantiate(Sprite, {
                    texture: starTexture,
                    position: new Point(starPositions[i].x, starPositions[i].y),
                    anchor: new Point(0.5, 0.5),
                });
                starSprite
                    .getComponent(TransformComponent)
                    .scale.set(0.59, 0.59);
                starContainer.addChild(starSprite);
            }

            starContainer.getComponent(TransformComponent).pivot.set(40, 0);

            this.addChild(starContainer);

            this.container.cacheAsBitmap = true;
        }
    }
}
